import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { InvoiceLineItem } from '../../../../../store/invoices/invoices.types'

const handleTextIput = (
  event: ChangeEvent<HTMLInputElement>,
  type: 'lineName' | 'description' | 'rate' | 'quantity' | 'lineTotal',
  line: InvoiceLineItem,
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
) => {
  const inputValue = event.target.value

  setLines((prevLines) =>
    prevLines?.map((prevLine) =>
      prevLine.id === line.id
        ? {
            ...prevLine,
            [type]:
              type === 'rate' || type === 'quantity'
                ? Number(inputValue)
                : inputValue,
          }
        : prevLine
    )
  )
}

const updateTotal = (
  event: ChangeEvent<HTMLInputElement>,
  type: 'rate' | 'quantity' | 'lineTotal',
  line: InvoiceLineItem,
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
) => {
  const inputValue = parseFloat(event.target.value)

  setLines((prevLines) =>
    prevLines?.map((prevLine) =>
      prevLine.id === line.id
        ? {
            ...prevLine,
            lineTotal:
              type === 'rate'
                ? inputValue * line.quantity
                : line.rate * inputValue,
          }
        : prevLine
    )
  )
}

export const handleChange = (
  event: ChangeEvent<HTMLInputElement>,
  type: 'lineName' | 'description' | 'rate' | 'quantity' | 'lineTotal',
  line: InvoiceLineItem,
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
) => {
  switch (type) {
    case 'lineName':
      handleTextIput(event, 'lineName', line, setLines)
      break
    case 'description':
      handleTextIput(event, 'description', line, setLines)
      break
    case 'rate':
      handleTextIput(event, 'rate', line, setLines)
      updateTotal(event, 'rate', line, setLines)
      break
    case 'quantity':
      handleTextIput(event, 'quantity', line, setLines)
      updateTotal(event, 'quantity', line, setLines)
      break
    case 'lineTotal':
      handleTextIput(event, 'lineTotal', line, setLines)
      updateTotal(event, 'lineTotal', line, setLines)
      break
  }
}
